<template>
  <div id="daohang">
    <ul>
      <li class="tab dropdown tex-c">
        <a href="/" class="tablink">首页</a>
      </li>
      <li v-for="(item,index) in newsClassList" :key="index" class="tab dropdown tex-c">
        <a @click="jump(item)" class="tablink">{{item.classCName}}</a>
        <ul class="subnav tex-c">
          <li v-for="(child,i) in item.child" :key="i">
            <a
              :href="child.isUrl == 1?child.urlAddress:child.classTemplet+'?classId='+child.classId"
            >{{child.classCName}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import Bus from "../assets/bus.js";
import newsClass from "../http/web/newsClass";
import news from '../http/web/news';
export default {
  data() {
    return {
      list: [
        "残联概况",
        "新闻中心",
        "政务信息",
        "政策法规",
        "互动交流",
        "办事服务",
        "专题专栏",
        "信息化"
      ],
      newsClassList: []
    };
  },
  beforeCreate: function() {
    // alert("调用了");
    newsClass.getNewClass().then(res => {
      // this.newsClassList = res;
      res.forEach(item => {
        if (this.list.indexOf(item.classCName) > -1) {
          this.newsClassList.push(item);
        }
      });
      this.sendBq(res);
    });
  },
  methods: {
    sendBq(bq) {
      Bus.$emit("val", bq);
    },
    jump(item) {
      news.countByClassId(item.classId).then(res => {
        if (res <= 0 && item.classTemplet != "/childClass") {
          window.location.href =
            item.isUrl == 1
              ? item.urlAddress
              : item.child[0].classTemplet +
                "?classId=" +
                item.child[0].classId;
        } else {
          window.location.href =
            item.isUrl == 1
              ? item.urlAddress
              : item.classTemplet + "?classId=" + item.classId;
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Daohang.vue